import { computed, shallowRef } from 'vue';
import { defineStore } from 'pinia';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { getMemberProductMap } from '~/utils/product';

export const useProductStore = defineStore('productStore', () => {
  const product = shallowRef<Product>(null as unknown as Product);

  const getAllMembers = computed(() => {
    // TODO break out member products in node so getter caching not needed
    if (!product.value?.id) {
      return {};
    }
    const memberProductMap = product.value.detail?.flags?.masterProduct ? getMemberProductMap(product.value) : undefined;
    const { killswitches } = useKillswitches();

    if (killswitches?.isPiniaMigrationEnabled) {
      return {
        [product.value.id]: product.value,
        ...memberProductMap,
      };
    }

    const { ccfp } = product.value;
    const data = { [product.value.id]: product.value };
    if (memberProductMap) {
      Object.entries(memberProductMap).forEach(([memberId, memberData]) => {
        data[memberId] = {
          ...memberData,
          ccfp,
        };
      });
    }
    return data;
  });

  return {
    product,
    getAllMembers,
  };
});

export default useProductStore;
